// import React from "react";
// import { database, auth } from '../firebase.js';
// import { ref, push, set, onValue, off, serverTimestamp } from 'firebase/database';
// import { onAuthStateChanged } from 'firebase/auth';

// const DesignNoTable = () => {
//   const [designs, setDesigns] = React.useState([]);
//   const [currentPage, setCurrentPage] = React.useState('table'); // 'table', 'addForm', 'editForm'
//   const [loading, setLoading] = React.useState(true);
//   const [currentUser, setCurrentUser] = React.useState(null);
//   const [editingDesign, setEditingDesign] = React.useState(null);
//   const [message, setMessage] = React.useState('');

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, '_');
//   };

//   // Validate design number - alphanumeric with special characters
//   const validateDesignNo = (designNo) => {
//     const regex = /^[a-zA-Z0-9\s\-_/()]+$/;
//     return regex.test(designNo.trim());
//   };

//   // Monitor authentication state
//   React.useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setCurrentUser(user);
//       } else {
//         setCurrentUser(null);
//         setDesigns([]);
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   // Fetch designs from Realtime Database
//   React.useEffect(() => {
//     if (!currentUser) {
//       setLoading(false);
//       return;
//     }

//     const encodedEmail = encodeEmailForPath(currentUser.email);
//     const designsRef = ref(database, `users/${encodedEmail}/designNumbers`);

//     const handleData = (snapshot) => {
//       const designsData = [];
//       snapshot.forEach((childSnapshot) => {
//         designsData.push({
//           id: childSnapshot.key,
//           ...childSnapshot.val()
//         });
//       });
//       setDesigns(designsData);
//       setLoading(false);
//     };

//     const handleError = (error) => {
//       console.error("Error fetching designs: ", error);
//       setLoading(false);
//     };

//     onValue(designsRef, handleData, handleError);

//     return () => {
//       off(designsRef, 'value', handleData);
//     };
//   }, [currentUser]);

//   // Styles matching GroupTable
//   const styles = {
//     container: {
//       maxWidth: '100%',
//       margin: '0 auto',
//       padding: '2rem',
//       minHeight: '100vh',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '2rem',
//       padding: '1.5rem',
//       backgroundColor: 'white',
//       borderRadius: '6px',
//       border: '1px solid #d1d5db',
//       fontWeight: '600',
//       color: '#374151',
//     },
//     title: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       color: '#2563eb',
//       margin: '0',
//     },
//     addButton: {
//       padding: '0.875rem 2rem',
//       borderRadius: '8px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.95rem',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//     },
//     tableContainer: {
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       overflow: 'hidden',
//       boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
//       border: '1px solid #e2e8f0',
//       overflowX: 'auto',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.9rem',
//       border: '1px solid #d1d5db',
//     },
//     tableHeader: {
//       padding: '1rem 0.75rem',
//       textAlign: 'left',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.85rem',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       border: '1px solid #1e40af',
//     },
//     tableCell: {
//       padding: '1rem 0.75rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       verticalAlign: 'middle',
//       textAlign: 'left',
//     },
//     noData: {
//       textAlign: 'center',
//       padding: '4rem 2rem',
//       color: '#718096',
//       fontSize: '1.1rem',
//     },
//     srNoCell: {
//       fontWeight: '600',
//       textAlign: 'center',
//       width: '60px',
//     },
//     actionCell: {
//       display: 'flex',
//       gap: '0.5rem',
//       justifyContent: 'flex-start',
//       alignItems: 'center',
//       padding: '0.5rem',
//     },
//     editButton: {
//       padding: '0.5rem',
//       borderRadius: '6px',
//       backgroundColor: '#10b981',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
//       transform: 'translateY(0)',
//     },
//     deleteButton: {
//       padding: '0.5rem',
//       borderRadius: '6px',
//       backgroundColor: '#ef4444',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)',
//       transform: 'translateY(0)',
//     },
//     formContainer: {
//       padding: '2rem',
//     },
//     formLabel: {
//       display: 'block',
//       color: '#374151',
//       fontWeight: 'bold',
//       fontSize: '1.125rem',
//       marginBottom: '0.75rem',
//     },
//     formInput: {
//       width: '100%',
//       padding: '1rem 1.5rem',
//       fontSize: '1.125rem',
//       border: '2px solid #e5e7eb',
//       borderRadius: '0.75rem',
//       outline: 'none',
//       transition: 'border-color 0.2s',
//       boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//       boxSizing: 'border-box',
//     },
//     formHint: {
//       color: '#6b7280',
//       fontSize: '0.875rem',
//       marginTop: '0.5rem',
//       margin: '0.5rem 0 0 0',
//     },
//     message: {
//       marginTop: '1.5rem',
//       padding: '1rem',
//       borderRadius: '0.75rem',
//       fontWeight: '500',
//       fontSize: '1rem',
//     },
//     successMessage: {
//       backgroundColor: '#f0fdf4',
//       color: '#166534',
//       border: '2px solid #bbf7d0',
//     },
//     errorMessage: {
//       backgroundColor: '#fef2f2',
//       color: '#b91c1c',
//       border: '2px solid #fecaca',
//     },
//   };

//   const AddDesignNoPage = ({ editDesign = null }) => {
//     const [designNo, setDesignNo] = React.useState(editDesign?.designNo || '');
//     const [message, setMessage] = React.useState('');

//     // Handle input change with validation
//     const handleDesignNoChange = (e) => {
//       const value = e.target.value;
//       // Allow alphanumeric and common special characters
//       const filteredValue = value.replace(/[^a-zA-Z0-9\s\-_/()]/g, '');
//       setDesignNo(filteredValue);
//     };

//     const handleSave = () => {
//       const trimmedDesignNo = designNo.trim();
      
//       if (!trimmedDesignNo) {
//         setMessage('Design no cannot be empty!');
//         return;
//       }

//       if (!validateDesignNo(trimmedDesignNo)) {
//         setMessage('Design no can only contain letters, numbers, spaces, and common symbols (-, _, /, ())!');
//         return;
//       }

//       if (!currentUser) {
//         setMessage('You must be logged in to add a design no');
//         return;
//       }

//       const encodedEmail = encodeEmailForPath(currentUser.email);

//       if (editDesign) {
//         // Edit existing design in Firebase
//         const designRef = ref(database, `users/${encodedEmail}/designNumbers/${editDesign.id}`);
//         set(designRef, {
//           designNo: trimmedDesignNo,
//           createdAt: editDesign.createdAt,
//           createdBy: currentUser.email
//         })
//         .then(() => {
//           setMessage('Design no updated successfully!');
//           setTimeout(() => {
//             setCurrentPage('table');
//             setEditingDesign(null);
//             setMessage('');
//           }, 2000);
//         })
//         .catch((error) => {
//           setMessage('Error updating design no: ' + error.message);
//         });
//       } else {
//         // Add new design to Firebase
//         const newDesignRef = push(ref(database, `users/${encodedEmail}/designNumbers`));
//         set(newDesignRef, {
//           designNo: trimmedDesignNo,
//           createdAt: serverTimestamp(),
//           createdBy: currentUser.email
//         })
//         .then(() => {
//           setMessage('Design no added successfully!');
//           setTimeout(() => {
//             setCurrentPage('table');
//             setEditingDesign(null);
//             setMessage('');
//           }, 2000);
//         })
//         .catch((error) => {
//           setMessage('Error saving design no: ' + error.message);
//         });
//       }
//     };

//     const handleCancel = () => {
//       setCurrentPage('table');
//       setEditingDesign(null);
//       setMessage('');
//     };

//     return (
//       <div style={styles.container}>
//         <div style={styles.header}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
//             <button
//               onClick={handleCancel}
//               style={{
//                 padding: '0.5rem',
//                 borderRadius: '0.5rem',
//                 border: 'none',
//                 backgroundColor: 'transparent',
//                 cursor: 'pointer',
//                 transition: 'background-color 0.2s',
//                 display: 'flex',
//                 alignItems: 'center'
//               }}
//               onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
//               onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               title="Back to Design No"
//             >
//               <svg style={{ width: '1.5rem', height: '1.5rem', color: '#6b7280' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
//               </svg>
//             </button>
//             <h1 style={styles.title}>
//               {editDesign ? 'Edit Design No' : 'Add New Design No'}
//             </h1>
//           </div>
//         </div>

//         <div style={styles.tableContainer}>
//           <div style={styles.formContainer}>
//             <h2 style={{
//               fontSize: '1.5rem',
//               fontWeight: 'bold',
//               color: '#2563eb',
//               marginBottom: '1rem'
//             }}>
//               Design Information
//             </h2>
            
//             <div style={{ maxWidth: '32rem' }}>
//               <div style={{ marginBottom: '2rem' }}>
//                 <label style={styles.formLabel}>
//                   Design No *
//                 </label>
//                 <input
//                   type="text"
//                   value={designNo}
//                   onChange={handleDesignNoChange}
//                   style={styles.formInput}
//                   onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
//                   onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
//                   placeholder="Enter design no"
//                 />
//               </div>
              
//               <div style={{ display: 'flex', gap: '1rem' }}>
//                 <button
//                   onClick={handleSave}
//                   style={styles.editButton}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = 'translateY(-2px)';
//                     e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = 'translateY(0)';
//                     e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
//                   }}
//                 >
//                   💾 {editDesign ? 'Update Design' : 'Save Design'}
//                 </button>
//                 <button
//                   onClick={handleCancel}
//                   style={{
//                     ...styles.editButton,
//                     backgroundColor: '#6b7280',
//                     boxShadow: '0 4px 15px rgba(107, 114, 128, 0.3)',
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = 'translateY(-2px)';
//                     e.target.style.boxShadow = '0 6px 20px rgba(107, 114, 128, 0.4)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = 'translateY(0)';
//                     e.target.style.boxShadow = '0 4px 15px rgba(107, 114, 128, 0.3)';
//                   }}
//                 >
//                   ❌ Cancel
//                 </button>
//               </div>
              
//               {message && (
//                 <div style={{
//                   ...styles.message,
//                   ...(message.includes('Error') || message.includes('cannot') || message.includes('can only') ? styles.errorMessage : styles.successMessage)
//                 }}>
//                   {message}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const handleEdit = (design) => {
//     setEditingDesign(design);
//     setCurrentPage('editForm');
//     setMessage('');
//   };

//   const handleDelete = (designId) => {
//     if (window.confirm('Are you sure you want to delete this design no?')) {
//       if (!currentUser) return;
      
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       const designRef = ref(database, `users/${encodedEmail}/designNumbers/${designId}`);
      
//       set(designRef, null)
//         .then(() => {
//           alert('Design no deleted successfully!');
//         })
//         .catch((error) => {
//           alert('Error deleting design no: ' + error.message);
//         });
//     }
//   };

//   if (currentPage === 'addForm') {
//     return <AddDesignNoPage />;
//   }

//   if (currentPage === 'editForm' && editingDesign) {
//     return <AddDesignNoPage editDesign={editingDesign} />;
//   }

//   if (!currentUser) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.noData}>
//           <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>🔐</div>
//           <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>Design No</h3>
//           <p>Please log in to view and manage your design no.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h1 style={styles.title}>Design No</h1>
//         <button
//           onClick={() => setCurrentPage('addForm')}
//           style={styles.addButton}
//           onMouseEnter={(e) => {
//             e.target.style.transform = 'translateY(-2px)';
//             e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.transform = 'translateY(0)';
//             e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//           }}
//         >
//           + Add New Design
//         </button>
//       </div>

//       <div style={styles.tableContainer}>
//         {loading ? (
//           <div style={styles.noData}>
//             <p>⏳ Loading design no...</p>
//           </div>
//         ) : designs.length > 0 ? (
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={{ ...styles.tableHeader, ...styles.srNoCell }}>Sr.No</th>
//                 <th style={styles.tableHeader}>Design No</th>
//                 <th style={styles.tableHeader}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {designs.map((design, index) => (
//                 <tr 
//                   key={design.id} 
//                   style={{
//                     backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
//                     transition: 'background-color 0.2s ease'
//                   }}
//                 >
//                   <td style={{ ...styles.tableCell, ...styles.srNoCell }}>{index + 1}</td>
//                   <td style={styles.tableCell}>{design.designNo}</td>
//                   <td style={{ ...styles.tableCell, ...styles.actionCell }}>
//                     <button
//                       onClick={() => handleEdit(design)}
//                       style={styles.editButton}
//                       title="Edit Design"
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-1px)';
//                         e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
//                       }}
//                     >
//                       ✏️
//                     </button>
//                     <button
//                       onClick={() => handleDelete(design.id)}
//                       style={styles.deleteButton}
//                       title="Delete Design"
//                       onMouseEnter={(e) => {
//                         e.target.style.transform = 'translateY(-1px)';
//                         e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.transform = 'translateY(0)';
//                         e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
//                       }}
//                     >
//                       🗑️
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         ) : (
//           <div style={styles.noData}>
//             <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>🎨</div>
//             <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>No Design No Found</h3>
//             <p style={{ marginBottom: '1.5rem' }}>Get started by adding your first design no!</p>
//             <button 
//               onClick={() => setCurrentPage('addForm')}
//               style={{
//                 ...styles.addButton,
//                 fontSize: '1rem',
//                 padding: '1rem 2rem'
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-2px)';
//                 e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
//               }}
//             >
//               + Add Your First Design
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DesignNoTable;

import React from "react";
import { database, auth } from '../firebase.js';
import { ref, push, set, onValue, off, serverTimestamp } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';

const DesignNoTable = () => {
  const [designs, setDesigns] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState('table'); // 'table', 'addForm', 'editForm'
  const [loading, setLoading] = React.useState(true);
  const [currentUser, setCurrentUser] = React.useState(null);
  const [editingDesign, setEditingDesign] = React.useState(null);
  const [message, setMessage] = React.useState('');

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, '_');
  };

  // Validate design number - alphanumeric with special characters
  const validateDesignNo = (designNo) => {
    const regex = /^[a-zA-Z0-9\s\-_/()]+$/;
    return regex.test(designNo.trim());
  };

  // Monitor authentication state
  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        setCurrentUser(null);
        setDesigns([]);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // Fetch designs from Realtime Database
  React.useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    const encodedEmail = encodeEmailForPath(currentUser.email);
    const designsRef = ref(database, `users/${encodedEmail}/designNumbers`);

    const handleData = (snapshot) => {
      const designsData = [];
      snapshot.forEach((childSnapshot) => {
        designsData.push({
          id: childSnapshot.key,
          ...childSnapshot.val()
        });
      });
      setDesigns(designsData);
      setLoading(false);
    };

    const handleError = (error) => {
      console.error("Error fetching designs: ", error);
      setLoading(false);
    };

    onValue(designsRef, handleData, handleError);

    return () => {
      off(designsRef, 'value', handleData);
    };
  }, [currentUser]);

  // Styles matching GroupTable
  const styles = {
    container: {
      maxWidth: '100%',
      margin: '0 auto',
      padding: '2rem',
      minHeight: '100vh',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '2rem',
      padding: '1.5rem',
      backgroundColor: 'white',
      borderRadius: '6px',
      border: '1px solid #d1d5db',
      fontWeight: '600',
      color: '#374151',
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#2563eb',
      margin: '0',
    },
    addButton: {
      padding: '0.875rem 2rem',
      borderRadius: '8px',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.95rem',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
      transform: 'translateY(0)',
    },
    tableContainer: {
      backgroundColor: 'white',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      overflowX: 'auto',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.9rem',
      border: '1px solid #d1d5db',
    },
    tableHeader: {
      padding: '1rem 0.75rem',
      textAlign: 'left',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      fontSize: '0.85rem',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      border: '1px solid #1e40af',
    },
    tableCell: {
      padding: '1rem 0.75rem',
      border: '1px solid #d1d5db',
      color: '#374151',
      verticalAlign: 'middle',
      textAlign: 'left',
    },
    noData: {
      textAlign: 'center',
      padding: '4rem 2rem',
      color: '#718096',
      fontSize: '1.1rem',
    },
    srNoCell: {
      fontWeight: '600',
      textAlign: 'center',
      width: '60px',
    },
    actionCell: {
      display: 'flex',
      gap: '0.5rem',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '0.5rem',
    },
    editButton: {
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#10b981',
      color: 'white',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.8rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
      transform: 'translateY(0)',
    },
    deleteButton: {
      padding: '0.5rem',
      borderRadius: '6px',
      backgroundColor: '#ef4444',
      color: 'white',
      fontWeight: '500',
      cursor: 'pointer',
      border: 'none',
      fontSize: '0.8rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)',
      transform: 'translateY(0)',
    },
    formContainer: {
      padding: '2rem',
    },
    formLabel: {
      display: 'block',
      color: '#374151',
      fontWeight: 'bold',
      fontSize: '1.125rem',
      marginBottom: '0.75rem',
    },
    formInput: {
      width: '100%',
      padding: '1rem 1.5rem',
      fontSize: '1.125rem',
      border: '2px solid #e5e7eb',
      borderRadius: '0.75rem',
      outline: 'none',
      transition: 'border-color 0.2s',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      boxSizing: 'border-box',
    },
    formHint: {
      color: '#6b7280',
      fontSize: '0.875rem',
      marginTop: '0.5rem',
      margin: '0.5rem 0 0 0',
    },
    message: {
      marginTop: '1.5rem',
      padding: '1rem',
      borderRadius: '0.75rem',
      fontWeight: '500',
      fontSize: '1rem',
    },
    successMessage: {
      backgroundColor: '#f0fdf4',
      color: '#166534',
      border: '2px solid #bbf7d0',
    },
    errorMessage: {
      backgroundColor: '#fef2f2',
      color: '#b91c1c',
      border: '2px solid #fecaca',
    },
  };

  const AddDesignNoPage = ({ editDesign = null }) => {
    const [designNo, setDesignNo] = React.useState(editDesign?.designNo || '');
    const [message, setMessage] = React.useState('');

    // Handle input change with validation
    const handleDesignNoChange = (e) => {
      const value = e.target.value;
      // Allow alphanumeric and common special characters
      const filteredValue = value.replace(/[^a-zA-Z0-9\s\-_/()]/g, '');
      setDesignNo(filteredValue);
    };

    const handleSave = () => {
      const trimmedDesignNo = designNo.trim();
      
      if (!trimmedDesignNo) {
        setMessage('Design no cannot be empty!');
        return;
      }

      if (!validateDesignNo(trimmedDesignNo)) {
        setMessage('Design no can only contain letters, numbers, spaces, and common symbols (-, _, /, ())!');
        return;
      }

      if (!currentUser) {
        setMessage('You must be logged in to add a design no');
        return;
      }

      const encodedEmail = encodeEmailForPath(currentUser.email);

      if (editDesign) {
        // Edit existing design in Firebase
        const designRef = ref(database, `users/${encodedEmail}/designNumbers/${editDesign.id}`);
        set(designRef, {
          designNo: trimmedDesignNo,
          createdAt: editDesign.createdAt,
          createdBy: currentUser.email
        })
        .then(() => {
          alert('Design no updated successfully!');
          setCurrentPage('table');
          setEditingDesign(null);
          setMessage('');
        })
        .catch((error) => {
          alert('Error updating design no: ' + error.message);
        });
      } else {
        // Add new design to Firebase
        const newDesignRef = push(ref(database, `users/${encodedEmail}/designNumbers`));
        set(newDesignRef, {
          designNo: trimmedDesignNo,
          createdAt: serverTimestamp(),
          createdBy: currentUser.email
        })
        .then(() => {
          alert('Design no added successfully!');
          setCurrentPage('table');
          setEditingDesign(null);
          setMessage('');
        })
        .catch((error) => {
          alert('Error saving design no: ' + error.message);
        });
      }
    };

    const handleCancel = () => {
      setCurrentPage('table');
      setEditingDesign(null);
      setMessage('');
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button
              onClick={handleCancel}
              style={{
                padding: '0.5rem',
                borderRadius: '0.5rem',
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                display: 'flex',
                alignItems: 'center'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              title="Back to Design No"
            >
              <svg style={{ width: '1.5rem', height: '1.5rem', color: '#6b7280' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <h1 style={styles.title}>
              {editDesign ? 'Edit Design No' : 'Add New Design No'}
            </h1>
          </div>
        </div>

        <div style={styles.tableContainer}>
          <div style={styles.formContainer}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#2563eb',
              marginBottom: '1rem'
            }}>
              Design Information
            </h2>
            
            <div style={{ maxWidth: '32rem' }}>
              <div style={{ marginBottom: '2rem' }}>
                <label style={styles.formLabel}>
                  Design No *
                </label>
                <input
                  type="text"
                  value={designNo}
                  onChange={handleDesignNoChange}
                  style={styles.formInput}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  placeholder="Enter design no"
                />
              </div>
              
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  onClick={handleSave}
                  style={styles.editButton}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
                  }}
                >
                  💾 {editDesign ? 'Update Design' : 'Save Design'}
                </button>
                <button
                  onClick={handleCancel}
                  style={{
                    ...styles.editButton,
                    backgroundColor: '#6b7280',
                    boxShadow: '0 4px 15px rgba(107, 114, 128, 0.3)',
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(107, 114, 128, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(107, 114, 128, 0.3)';
                  }}
                >
                  ❌ Cancel
                </button>
              </div>
              
              {message && (
                <div style={{
                  ...styles.message,
                  ...(message.includes('Error') || message.includes('cannot') || message.includes('can only') ? styles.errorMessage : styles.successMessage)
                }}>
                  {message}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleEdit = (design) => {
    setEditingDesign(design);
    setCurrentPage('editForm');
    setMessage('');
  };

  const handleDelete = (designId) => {
    if (window.confirm('Are you sure you want to delete this design no?')) {
      if (!currentUser) return;
      
      const encodedEmail = encodeEmailForPath(currentUser.email);
      const designRef = ref(database, `users/${encodedEmail}/designNumbers/${designId}`);
      
      set(designRef, null)
        .then(() => {
          alert('Design no deleted successfully!');
        })
        .catch((error) => {
          alert('Error deleting design no: ' + error.message);
        });
    }
  };

  if (currentPage === 'addForm') {
    return <AddDesignNoPage />;
  }

  if (currentPage === 'editForm' && editingDesign) {
    return <AddDesignNoPage editDesign={editingDesign} />;
  }

  if (!currentUser) {
    return (
      <div style={styles.container}>
        <div style={styles.noData}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>🔐</div>
          <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>Design No</h3>
          <p>Please log in to view and manage your design no.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Design No</h1>
        <button
          onClick={() => setCurrentPage('addForm')}
          style={styles.addButton}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
          }}
        >
          + Add New Design
        </button>
      </div>

      <div style={styles.tableContainer}>
        {loading ? (
          <div style={styles.noData}>
            <p>⏳ Loading design no...</p>
          </div>
        ) : designs.length > 0 ? (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.tableHeader, ...styles.srNoCell }}>Sr.No</th>
                <th style={styles.tableHeader}>Design No</th>
                <th style={styles.tableHeader}>Action</th>
              </tr>
            </thead>
            <tbody>
              {designs.map((design, index) => (
                <tr 
                  key={design.id} 
                  style={{
                    backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  <td style={{ ...styles.tableCell, ...styles.srNoCell }}>{index + 1}</td>
                  <td style={styles.tableCell}>{design.designNo}</td>
                  <td style={{ ...styles.tableCell, ...styles.actionCell }}>
                    <button
                      onClick={() => handleEdit(design)}
                      style={styles.editButton}
                      title="Edit Design"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
                      }}
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => handleDelete(design.id)}
                      style={styles.deleteButton}
                      title="Delete Design"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
                      }}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div style={styles.noData}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem', opacity: '0.5' }}>🎨</div>
            <h3 style={{ color: '#4a5568', marginBottom: '0.5rem' }}>No Design No Found</h3>
            <p style={{ marginBottom: '1.5rem' }}>Get started by adding your first design no!</p>
            <button 
              onClick={() => setCurrentPage('addForm')}
              style={{
                ...styles.addButton,
                fontSize: '1rem',
                padding: '1rem 2rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(37, 99, 235, 0.3)';
              }}
            >
              + Add Your First Design
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DesignNoTable;